<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Módulos por Plan</h4>
    <hr />

    <DataTable
      :data="moduplans"
      :columns="[
        { label: 'Plan',   field: 'planNombre'   },
        { label: 'Módulo', field: 'moduloNombre' },
      ]"
      idField="idModuPlan"
      mensajeVacio="No hay registros de módulos por plan."
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idModuPlan)"
      @view="row => abrirEditar(row.idModuPlan)"
      @delete="row => deleteModuPlan(row.idModuPlan)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoModuPlan.idModuPlan" disabled />
                </div>
              </div>
            </div>
            <!-- Módulo -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Módulo</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoModuPlan.idModulo">
                    <option disabled value="">Seleccione...</option>
                    <option
                      v-for="modulo in modulos"
                      :value="modulo.idModulo"
                      :key="modulo.idModulo"
                    >
                      {{ modulo.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Plan -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Plan</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoModuPlan.idPlan">
                    <option disabled value="">Seleccione...</option>
                    <option
                      v-for="plan in plans"
                      :value="plan.idPlan"
                      :key="plan.idPlan"
                    >
                      {{ plan.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarModuPlan"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarModuPlan"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      moduplans:    [],
      datoModuPlan: {},
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      modulos:      [],
      plans:        [],
    };
  },
  mounted() {
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchModulos();
    this.fetchPlans();
  },
  methods: {
    getDataPaginaTodos() {
      api.get("/vwmoduplans")
        .then(r => { this.moduplans = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar módulos por plan:", e));
    },
    validarForm() {
      return validarForm(
        this.datoModuPlan,
        ["idModulo", "idPlan"],
        ["idModulo", "idPlan"]
      );
    },
    async guardarModuPlan() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/moduplans", this.datoModuPlan);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro creado exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarModuPlan() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/moduplans", this.datoModuPlan);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro actualizado exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteModuPlan(idModuPlan) {
      const confirm = await Swal.fire({
        title: "¿Eliminar registro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/moduplans/" + idModuPlan);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoModuPlan = {};
      this.titulo       = "Crear Módulo por Plan";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idModuPlan) {
      this.modalWindow = true;
      this.titulo      = "Editar Módulo por Plan";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwmoduplans/" + idModuPlan);
        this.datoModuPlan = resp.data;
      } catch (e) {
        console.error("Error al cargar módulo por plan:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idModuPlan) {
      if (idModuPlan != null) this.$router.push("/moduplanmd/" + idModuPlan);
    },
    async fetchModulos() {
      try {
        const r    = await api.get("/modulos");
        this.modulos = r.data;
      } catch (e) {
        console.error("Error fetching modulos:", e);
      }
    },
    async fetchPlans() {
      try {
        const r  = await api.get("/plans");
        this.plans = r.data;
      } catch (e) {
        console.error("Error fetching plans:", e);
      }
    },
  },
};
</script>